import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const AuthTokenStorageKey = 'moxieAuthToken'
export const authTokenAtom = atomWithStorage<string | undefined>(AuthTokenStorageKey, undefined, undefined, {
    getOnInit: true,
})

export const useAuthToken = () => {
    const [authToken] = useAtom(authTokenAtom)

    return authToken
}
